import React, { useState, useEffect } from 'react';
import { Modal } from 'antd';
import { apiHolder } from 'api';
import { transContactModel2ContactItem } from '@web-common/components/util/contact';
import SelectList from '../selectList';
import SelectedList from '../selectedList';
import styles from './index.module.scss';
import useContactItemEffect from '@web-common/components/UI/SiriusContact/useContactItemEffect';
import { getIn18Text } from 'api';
const systemApi = apiHolder.api.getSystemApi();
const SiriusContactModal = props => {
    const { showAddOrgBtn, showAddTeamBtn, showAddPersonalBtn, showFooter = true, showTitle = true, type, useEdm, searchType, isIM, visible = true, onCancel, onSure, onSelect, defaultSelectList = [], modalProps, includeSelf, firstPositionNotDelEmail, noRelateEnterprise, accountRootKey, useMultiAccount, } = props;
    const { multiple, showCheckbox } = props;
    const [selectList, setSelectList] = useState([]);
    const [needScrollBottom, setNeedScrollBottom] = useState(true);
    const [disableCheckList, setDisableCheckList] = useState([]);
    const [canSure, setSure] = useState(true);
    const user = systemApi.getCurrentUser();
    const handleSelect = (itemList, contactList) => {
        setSelectList(itemList);
        setNeedScrollBottom(true);
        onSelect && onSelect(itemList, contactList);
    };
    const handleDelete = (itemList, contactList) => {
        setSelectList(itemList);
        setNeedScrollBottom(false);
        onSelect && onSelect(itemList, contactList);
    };
    const handleCancel = () => {
        setSelectList(defaultSelectList ? [...defaultSelectList] : []);
        onCancel && onCancel(selectList);
    };
    const handleSure = () => {
        onSure && onSure(selectList);
    };
    useContactItemEffect(defaultSelectList, () => {
        if (defaultSelectList.length) {
            setSure(true);
        }
        setSelectList(defaultSelectList);
        setNeedScrollBottom(true);
    });
    useEffect(() => {
        if (!includeSelf) {
            (user === null || user === void 0 ? void 0 : user.contact) && setDisableCheckList([transContactModel2ContactItem(user.contact)]);
        }
    }, [user, includeSelf]);
    useEffect(() => {
        if (selectList.length > 0) {
            setSure(true);
        }
        else {
            setSure(false);
        }
    }, [selectList]);
    return (React.createElement(Modal, Object.assign({ visible: visible, closable: false, width: 680, footer: null, title: null, destroyOnClose: true, bodyStyle: { padding: 0 } }, modalProps),
        React.createElement("div", { className: styles.modalContainer },
            React.createElement("div", { className: styles.modalTitle, hidden: !showTitle },
                React.createElement("span", null, getIn18Text('XUANZELIANXIREN')),
                React.createElement("span", { className: `dark-invert ${styles.close}`, onClick: handleCancel })),
            React.createElement("div", { className: styles.modalBody },
                React.createElement("div", { className: styles.bodyLeft },
                    React.createElement(SelectList, { accountRootKey: accountRootKey || (user === null || user === void 0 ? void 0 : user.id), showNoDataPlaceholder: true, useEdm: useEdm, isIM: isIM, searchType: searchType, type: type, showAddOrgBtn: showAddOrgBtn, showAddTeamBtn: showAddTeamBtn, showAddPersonalBtn: showAddPersonalBtn, disableCheckList: disableCheckList, useMultiAccount: useMultiAccount, defaultSelectList: selectList, onSelect: handleSelect, containerHeight: "100%", multiple: multiple, showCheckbox: showCheckbox, noRelateEnterprise: noRelateEnterprise })),
                React.createElement("div", { className: styles.bodyRight },
                    React.createElement(SelectedList, { firstPositionNotDelEmail: firstPositionNotDelEmail, needScrollBottom: needScrollBottom, selectList: selectList, onDelete: handleDelete, onCancel: handleCancel, onSure: handleSure, canSure: canSure, showPosition: true, showFooter: showFooter }))))));
};
export default SiriusContactModal;
